export default __webpack_public_path__ + "static/media/IBimageHipextensionTerminalStance2.ab0ba25b.png";